import { useState, useEffect } from "react";
import { Form, Input, Button, Alert, message } from "antd";

import { KeyOutlined, LockOutlined } from "@ant-design/icons";
import "../scss/reset-password-update.scss";
import { useNavigate, useParams } from "react-router-dom";
import AuthService from "../utils/api/auth";

export default function ResetPassword() {
  const { tokenUrl } = useParams();
  const [feedback, setFeedback] = useState({
    isSuccess: false,
    isError: false,
    message: "",
  });

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [load, setLoad] = useState(false);
  const formValues = Form.useWatch([], form);
  const [submitableForm, setSubmitableForm] = useState(false);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmitableForm(true);
        },
        () => {
          setSubmitableForm(false);
        }
      );
  }, [formValues]);

  const onFinish = (values) => {
    setLoad(true);
    setFeedback({ isSuccess: false, isError: false, message: "" });

    AuthService.PasswordReset(tokenUrl, values.password)
      .then((response) => {
        const successValue = response?.data?.success;

        if (successValue === true || successValue === "true" || successValue === 1) {
          setFeedback({
            isSuccess: true,
            message: response?.data?.message || "Contrasena actualizada correctamente.",
          });
          message.success("Su contrasena se actualizo correctamente. Redirigiendo al inicio de sesion...").then(() => {
            navigate("/");
          });
        } else {
          setFeedback({
            isError: true,
            message: response?.data?.message || "No fue posible actualizar la contrasena.",
          });
        }
      })
      .catch(() => {
        setFeedback({
          isError: true,
          message: "Hubo un error al actualizar la contrasena, intenta de nuevo.",
        });
      })
      .finally(() => {
        setLoad(false);
      });
  };

  return (
    <div className="reset-update-page">
      <div className="reset-update-card">
        <div className="reset-update-header">
          <div className="reset-update-key-wrap">
            <KeyOutlined className="reset-update-key-icon" />
          </div>
          <h1 className="reset-update-title">Nueva contrasena</h1>
          <p className="reset-update-subtitle">Crea una contrasena segura para tu cuenta</p>
        </div>

        <div className="reset-update-content">
      {feedback.isError && (
        <div className="reset-update-alert">
          <Alert message={feedback.message} type="error" closable />
        </div>
      )}
      {feedback.isSuccess && (
        <div className="reset-update-alert">
          <Alert message={feedback.message} type="success" closable />
        </div>
      )}
      <Form
        onFinish={onFinish}
        form={form}
        layout="vertical"
        className="reset-update-form"
      >
        <Form.Item
          label={<span className="reset-update-label">Nueva contrasena</span>}
          name="password"
          rules={[
            {
              required: true,
              message: "Favor de escribir su contraseña.",
            },
            {
              min: 8,
              message: "La contraseña debe contener al menos 8 caracteres",
            },
          ]}
          className="reset-update-form-item"
        >
          <Input.Password
            className="reset-update-input"
            prefix={<LockOutlined className="reset-update-input-icon" />}
            placeholder="Minimo 8 caracteres"
          />
        </Form.Item>

        <Form.Item
          label={<span className="reset-update-label">Confirmar contrasena</span>}
          name="password_confirmation"
          dependencies={["password"]}
          rules={[
            {
              required: true,
              message: "Favor de confirmar la contraseña.",
            },
            {
              min: 8,
              message: "La contraseña debe contener al menos 8 caracteres",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                return !value || getFieldValue("password") === value
                  ? Promise.resolve()
                  : Promise.reject(new Error("Las contrasenas no coinciden."));
              },
            }),
          ]}
          className="reset-update-form-item"
        >
          <Input.Password
            className="reset-update-input"
            prefix={<LockOutlined className="reset-update-input-icon" />}
            placeholder="Repite tu contrasena"
          />
        </Form.Item>
        <Form.Item className="reset-update-submit-item">
          <Button
            className="reset-update-submit-btn"
            type="primary"
            htmlType="submit"
            block={true}
            loading={load}
            disabled={!submitableForm}
          >
            Guardar nueva contrasena
          </Button>
        </Form.Item>
      </Form>

      </div>
      </div>

      <p className="reset-update-support">
        ¿Necesitas ayuda? {" "}
        <a className="reset-update-support-link" href="mailto:soporte@epno.com.mx">
          Contacta con soporte
        </a>
      </p>
    </div>
  );
}
